'use client'

import React, { useState } from 'react'
import styles from './TerminalTabs.module.css'
import Holdings from './Holdings'
import OrderHistory from './OrderHistory'
import TradeHistory from './TradeHistory'
import OpenOrders from './OpenOrders'

const TABS = ['Open Orders', 'Order History', 'Trade History', 'Holdings']

export default function TerminalTabs() {
  const [activeTab, setActiveTab] = useState<string>(TABS[0])

  const renderTabContent = () => {
    switch (activeTab) {
      case 'Open Orders':
        return <OpenOrders />
      case 'Order History':
        return <OrderHistory />
      case 'Trade History':
        return <TradeHistory />
      case 'Holdings':
        return <Holdings />
      default:
        return null
    }
  }

  return (
    <div className={styles.tabsContainer}>
      <ul className={styles.tabList}>
        {TABS.map(tab => (
          <li
            key={tab}
            className={`${styles.tabItem} ${
              tab === activeTab ? styles.activeTab : ''
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </li>
        ))}
      </ul>
      <div className={styles.tabContent}>{renderTabContent()}</div>
    </div>
  )
}
